import NextImage from '@/components/cms/image';
import { MediaData } from '@/components/cms/types';
import WPTypography from '@/components/typography';
import { Button } from '@drivekyte/ui';
import { Box, Container, Grid } from '@drivekyte/web-components';
import dayjs from 'dayjs';
import { useRouter } from 'next/router';

type MainPostType = {
  title: string;
  author: string;
  ctaButtonLabel: string;
  slug: string;
  date: string;
  image: MediaData;
};

const MainPost = ({
  title,
  author,
  ctaButtonLabel,
  date,
  slug,
  image,
}: MainPostType) => {
  const router = useRouter();

  const handlePress = () => {
    router.push(`/blog/${slug}`);
  };

  return (
    <Container>
      <Box
        display="flex"
        flexDirection="row"
        paddingBottom="xLarge"
        paddingTop="xLarge"
        width="100%"
        maxWidth="1280px"
      >
        <Grid container spacing={5}>
          <Grid item md={5} sm={12}>
            <Box display="flex" alignItems="center" height="100%">
              <Box>
                <WPTypography
                  variant="span"
                  color="primary"
                  fontSize={16}
                  lineHeight={28}
                  fontWeight={400}
                >
                  {dayjs(date).format('MMM D, YYYY')}
                </WPTypography>
                <Box onPress={handlePress} cursor="pointer">
                  <WPTypography
                    variant="h2"
                    color="primary"
                    fontFamily="Gilroy"
                    fontSize={48}
                    lineHeight={64}
                    fontWeight={700}
                  >
                    {title}
                  </WPTypography>
                </Box>
                <WPTypography
                  variant="span"
                  color="primary"
                  fontSize={16}
                  lineHeight={28}
                  fontWeight={400}
                >
                  by {author}
                </WPTypography>
                <Box marginTop="small">
                  <Button
                    variant="primary"
                    onPress={handlePress}
                    maxWidth="25%"
                    height={48}
                  >
                    {ctaButtonLabel}
                  </Button>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item md={7} sm={12}>
            <Box
              width="750px"
              height="502px"
              position="relative"
              borderRadius="base"
            >
              <NextImage
                media={image}
                borderRadius="8px"
                fill={true}
                priority={true}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default MainPost;
